import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";
import ShopHome from "./pages/Shop";
import AccountPage, { BrandsPage, BreedsPage, BreedPage } from "./pages/Account";
import { AccountProvider } from "./store/AccountContext";
import ShopListing from "./pages/ShopListing";
import ProductPage from "./pages/ProductPage";
import Checkout from "./pages/Checkout";
import TrackOrder, { OrderSuccess } from "./pages/TrackOrder";
import { CartProvider } from "./store/CartContext";
import AdminProducts from "./admin/AdminProducts";
import AdminOrders from "./admin/AdminOrders";
import AdminSlides from "./admin/AdminSlides";
import AdminReviews from "./admin/AdminReviews";

import { AuthProvider } from "./admin/AuthContext";
import ProtectedRoute from "./admin/ProtectedRoute";
import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminBookings from "./admin/AdminBookings";
import AdminEnquiries from "./admin/AdminEnquiries";
import AdminReminders from "./admin/AdminReminders";
import AdminReports from "./admin/AdminReports";
import AdminTeam from "./admin/AdminTeam";
import AdminTasks from "./admin/AdminTasks";
import AdminBlog from "./admin/AdminBlog";
import RouteTitle from "./components/RouteTitle";
import GAPageView from "./components/GAPageView";
import { Toaster } from "./components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
        <AccountProvider>
        <BrowserRouter>
          <RouteTitle />
          <GAPageView />
          <Routes>
            {/* Public website */}
            <Route element={<Layout />}>
              <Route path="/" element={<ShopHome />} />
              <Route path="/grooming" element={<Home />} />
              <Route path="/brands" element={<BrandsPage />} />
              <Route path="/breeds" element={<BreedsPage />} />
              <Route path="/breeds/:slug" element={<BreedPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/shop" element={<ShopHome />} />
              <Route path="/shop/all" element={<ShopListing />} />
              <Route path="/shop/c/:category" element={<ShopListing />} />
              <Route path="/shop/p/:slug" element={<ProductPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:orderNumber" element={<OrderSuccess />} />
              <Route path="/track-order" element={<TrackOrder />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="enquiries" element={<AdminEnquiries />} />
              <Route path="reminders" element={<AdminReminders />} />
              <Route path="tasks" element={<AdminTasks />} />
              <Route path="products" element={<ProtectedRoute roles={["admin", "staff"]}><AdminProducts /></ProtectedRoute>} />
              <Route path="slides" element={<AdminSlides />} />
              <Route path="reviews" element={<ProtectedRoute roles={["admin", "staff"]}><AdminReviews /></ProtectedRoute>} />
              <Route path="orders" element={<ProtectedRoute roles={["admin", "staff"]}><AdminOrders /></ProtectedRoute>} />
              <Route path="blog" element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminBlog />
                </ProtectedRoute>
              } />
              <Route path="reports" element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminReports />
                </ProtectedRoute>
              } />
              <Route path="team" element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminTeam />
                </ProtectedRoute>
              } />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
          {/* Global toaster */}
          <Toaster richColors theme="dark" position="top-right" />
        </BrowserRouter>
        </AccountProvider>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
